import React from 'react';
import Dictionary from '../../../../utils/dictionary';
import useDictionary from '../../../../hooks/useDictionary';
import MuiModal from '../MuiModal';
import FlightSummary from '../FlightSummary';

const DetailsModal = ({ modalOpen, handleCloseModal, guestsByLocator }) => {
  const getDictionaryValue = useDictionary(Dictionary);

  const guestNames = guestsByLocator.map(
    (guestData) =>
      `${guestData.flightGuest.firstName.toLowerCase()} ${guestData.flightGuest.lastName.toLowerCase()}`,
  );

  return (
    <MuiModal
      customClass={{ width: '70vw', maxWidth: '1025px' }}
      modalStatus={modalOpen}
      handleClose={handleCloseModal}
      showCloseButton
      title={getDictionaryValue(Dictionary.airModalCancellationTitle.key)}>
      <FlightSummary
        key="flight-summary-modal"
        flight={guestsByLocator[0].flightGuest.guestFlights}
        passengers={guestNames.join(', ')}
      />
    </MuiModal>
  );
};

export default DetailsModal;
